module.exports = __webpack_public_path__ + "img/ico_marker_station.fce276a6.png";